

import './Contact.css';
import React, { useState } from 'react';

const Contact = () => {
  const [form, setForm] = useState({ name: '', tel: '', email: '', message: '' });
  const [status, setStatus] = useState({ loading: false, success: null, error: null });

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus({ loading: true, success: null, error: null });
    try {
      const res = await fetch('https://sedertravel.sa/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (data.success) {
        setStatus({ loading: false, success: 'Message sent successfully!', error: null });
        setForm({ name: '', tel: '', email: '', message: '' });
      } else {
        setStatus({ loading: false, success: null, error: data.message || 'Failed to send message.' });
      }
    } catch (err) {
      setStatus({ loading: false, success: null, error: 'Error sending message.' });
    }
  };

  return (
  <section id="contact" className="contact" style={{ background: '#f7f8fd', padding: '4rem 0' }}>
    <h2 style={{ textAlign: 'center', fontSize: '2.3rem', color: '#2E3387', marginBottom: '2.5rem', letterSpacing: '0.01em' }}>Contact Us</h2>
    <div className="contact-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '3rem', maxWidth: 1400, margin: '0 auto', background: '#fff', borderRadius: 18, boxShadow: '0 4px 24px rgba(46,51,135,0.10)', padding: '2.5rem 2rem' }}>
      <form id="contact-form" onSubmit={handleSubmit} style={{ flex: 1, minWidth: 270, display: 'flex', flexDirection: 'column', gap: '1.2rem' }} autoComplete="off">
        <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Your Name" required style={{ padding: '0.9rem 1.2rem', borderRadius: 8, border: '1px solid #e3e6fa', fontSize: '1rem', background: '#f7f8fd' }} />
        <input
          type="tel"
          name="tel"
          value={form.tel}
          onChange={handleChange}
          pattern="^\+9665\d{8}$"
          placeholder="+9665XXXXXXXX"
          minLength="13"
          maxLength="13"
          title="Please enter a valid Saudi mobile number (e.g. +9665XXXXXXXX)"
          required
          style={{ padding: '0.9rem 1.2rem', borderRadius: 8, border: '1px solid #e3e6fa', fontSize: '1rem', background: '#f7f8fd' }}
        />
        <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Your Email" required style={{ padding: '0.9rem 1.2rem', borderRadius: 8, border: '1px solid #e3e6fa', fontSize: '1rem', background: '#f7f8fd' }} />
        <textarea name="message" value={form.message} onChange={handleChange} placeholder="Your Message" required rows={5} style={{ padding: '1rem 1.2rem', borderRadius: 8, border: '1px solid #e3e6fa', fontSize: '1rem', background: '#f7f8fd', resize: 'vertical' }}></textarea>
        <button type="submit" className="submit-button" style={{ background: 'linear-gradient(90deg, #2E3387 0%, #4e54c8 100%)', color: '#fff', border: 'none', padding: '0.9rem 0', borderRadius: 8, fontWeight: 600, fontSize: '1.08rem', marginTop: '0.5rem', boxShadow: '0 2px 8px rgba(46,51,135,0.08)', cursor: 'pointer', letterSpacing: '0.01em', transition: 'background 0.2s, box-shadow 0.2s' }}>Send Message</button>
      </form>
      <div className="contact-info" style={{ flex: 1, minWidth: 250, display: 'flex', flexDirection: 'column', gap: '1.5rem', justifyContent: 'center' }}>
        <div className="contact-info-title" style={{
          textAlign: 'left',
          color: '#2E3387',
          fontWeight: 700,
          fontSize: '1.35rem',
          marginBottom: '0.7rem',
          letterSpacing: '0.01em',
          display: 'flex',
          alignItems: 'center',
          gap: '0.7rem',
        }}>
          <i className="fas fa-globe-asia" style={{ fontSize: '1.6rem', color: '#4e54c8' }}></i>
          <span>"Your Journey, Our Passion"</span>
        </div>
        <div className="info-item" style={{ display: 'flex', alignItems: 'center', gap: '1rem', color: '#2E3387', fontWeight: 500, fontSize: '1.08rem' }}>
          <span style={{ fontSize: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="fas fa-briefcase"></i></span>
          <span>Travel & Tourism Agency</span>
        </div>
        <div className="info-item" style={{ display: 'flex', alignItems: 'center', gap: '1rem', color: '#2E3387', fontWeight: 500, fontSize: '1.08rem' }}>
          <span style={{ fontSize: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="fas fa-map-marker-alt"></i></span>
          <span>QHQQ+MW Al Malqa - Riyadh, Saudi Arabia</span>
        </div>
        <div className="info-item" style={{ display: 'flex', alignItems: 'center', gap: '1rem', color: '#2E3387', fontWeight: 500, fontSize: '1.08rem' }}>
          <span style={{ fontSize: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="fas fa-phone"></i></span>
          <span>+011 460 6666</span>
        </div>
        <div className="info-item" style={{ display: 'flex', alignItems: 'center', gap: '1rem', color: '#2E3387', fontWeight: 500, fontSize: '1.08rem' }}>
          <span style={{ fontSize: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="fas fa-envelope"></i></span>
          <span>info@sedertravel.sa</span>
        </div>
        <div className="info-item" style={{ display: 'flex', alignItems: 'center', gap: '1rem', color: '#2E3387', fontWeight: 500, fontSize: '1.08rem' }}>
          <span style={{ fontSize: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="fas fa-id-badge"></i></span>
          <span>License No: 73105703</span>
        </div>
      </div>
    </div>
  </section>
);
}
export default Contact;
